import { motion, useReducedMotion } from "framer-motion";

/**
 * Full-screen intro / Suspense fallback. Themed via the design tokens rather
 * than the hardcoded #000/#fff of the old ring spinner.
 */
export default function Loader() {
  const reduced = useReducedMotion();

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-6">
        <div className="flex items-end gap-[6px]" aria-hidden="true">
          {[0, 1, 2, 3].map((i) => (
            <motion.span
              key={i}
              className="block w-[3px] bg-primary"
              initial={{ height: 8 }}
              animate={reduced ? { height: 24 } : { height: [8, 32, 8] }}
              transition={
                reduced
                  ? { duration: 0 }
                  : {
                      duration: 1,
                      repeat: Infinity,
                      ease: "easeInOut",
                      delay: i * 0.12,
                    }
              }
            />
          ))}
        </div>
        <p className="u-label text-muted-foreground">Loading</p>
      </div>
    </div>
  );
}
